import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../api-client.config';
import { queryKeys, type RequestBody } from '../react-query.config';
import { toast } from 'sonner';
import { useNavigate } from '@tanstack/react-router';

type UpdateQuestionRequest = RequestBody<'/api/admin/questions', 'post'>; // Backend uses same schema as POST

interface UpdateQuestionParams {
  pickemId: string;
  questionId: string;
  data: UpdateQuestionRequest;
}

// Use legacy axios client for now until API types are regenerated
export const updateQuestion = ({ questionId, data }: UpdateQuestionParams) =>
  api.put(`/questions/${questionId}`, data);

export const useUpdateQuestionMutation = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: updateQuestion,
    onSuccess: (_response, variables) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.questions.all });
      queryClient.invalidateQueries({ queryKey: queryKeys.pickems.all });
      toast.success('Question updated successfully');

      // Navigate back to the pickem's questions list
      const pickemId = variables.pickemId;
      if (pickemId) {
        navigate({
          to: '/dashboard/pickems/$id',
          params: { id: pickemId },
          search: { tenant_id: undefined, tab: 'questions' },
        });
      } else {
        // Fallback to pickems list if no pickemId
        navigate({ to: '/dashboard/pickems' });
      }
    },
    onError: (error: any) => {
      toast.error(error.message || 'Failed to update question');
    },
  });
};
